import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '../components/ui/buttons';
import { Input } from '../components/ui/input';
import { recoverPassword } from '../services/login';

interface Fields {
  password: string;
  'confirm-password': string;
}

const RecoveryPassword: React.FC = () => {
  const { token, userId } = useParams();
  const methods = useForm<Fields>();
  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  if (!token || !userId) {
    window.location.href = '/';
    return <></>;
  }

  const handleSubmit = async (data: Fields) => {
    try {
      setLoading(true);
      if (data.password !== data['confirm-password']) {
        throw new Error('As senhas precisam ser iguais.');
      }

      await recoverPassword(token, userId, { password: data.password });

      alert('Senha alterada com sucesso!');

      window.location.href = '/';
    } catch (error) {
      console.error(error);
      alert('Ocorreu um erro ao alterar a senha!');
    } finally {
      setLoading(false);
      methods.reset();
    }
  };

  return (
    <Container>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <Card>
            <Title>Preencha os campos para alterar a senha</Title>

            <InputWrapper>
              <Label>
                Nova Senha
                <Input
                  {...methods.register('password', { required: 'Digite a nova senha', minLength: 6 })}
                  placeholder="Digite sua nova senha"
                  type={showPassword ? 'text' : 'password'}
                  minLength={6}
                />
              </Label>
              <Label>
                Confirme sua senha
                <Input
                  {...methods.register('confirm-password', { required: 'Digite a confirmação da senha', minLength: 6 })}
                  placeholder="Confirme sua nova senha"
                  type={showPassword ? 'text' : 'password'}
                  minLength={6}
                />
              </Label>
            </InputWrapper>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
              <a style={{ cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? 'Esconder senha' : 'Mostrar senha'}
              </a>
            </div>
            <Button label="Alterar Senha" type="submit" loading={loading} />
          </Card>
        </form>
      </FormProvider>
    </Container>
  );
};

const Title = styled.h1`
  font-size: 22px;
`;

const Label = styled.label`
  font-size: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const InputWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 100vh;
  background: rgb(0, 150, 255);
  padding: 16px;
`;

const Card = styled.div`
  border: 1px solid #dee2e6;
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px;
  max-width: 500px;
`;

export default RecoveryPassword;
